export default __webpack_public_path__ + "static/media/fail.14281694.svg";